import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
/**
 * @summary BaseSearchLicenseFilters
 * @extends {mAoflElement}
 */
@customElement('base-search-license-filters')
class BaseSearchLicenseFilters extends AoflElement {
  /**
   * Creates an instance of BaseSearchLicenseFilters.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'base-search-license-filters';

  @property({type: String, attribute: false})
  licenseStatus = '';

  @property({type: Array})
  licenseStatuses = [];

  @property({type: String, attribute: false})
  license = '';

  @property({type: String, attribute: false})
  product = '';

  @property({type: Boolean})
  showLicenses = true;

  @property({type: Boolean, attribute: false})
  showLicensesFromRoot = false;

  /**
   *
   * @protected
   * @param {CustomEvent} e
   */
  filterUpdated(e) {}

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export {
  BaseSearchLicenseFilters
};
